{
  "familyId": "SWW-VD-STERK",
  "questions": [
    {
      "id": "SWW-VD-STERK-001",
      "familyId": "SWW-VD-STERK",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_sterk",
      "questionType": "multiple_choice",
      "question": "Wat is het voltooid deelwoord van 'lopen'?",
      "options": ["gelopen", "geloopt", "geloopen", "gelopd"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "VD van sterke werkwoorden", "content": "Sterke werkwoorden veranderen van klinker in de verleden tijd. Het VD eindigt op -en (niet op -t of -d).\n\nlopen → liep → gelopen\nschrijven → schreef → geschreven\n\nPatroon: ge- + veranderde stam + -en", "icon": "lightbulb" } }
      ],
      "conceptId": "vd_sterk_lopen",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Lopen' is een sterk werkwoord: lopen → liep → gelopen. Het VD eindigt op -en. Onthoud: bij sterke werkwoorden gebruik je NOOIT 't kofschip voor het VD.",
        "solutionSteps": ["Lopen is een sterk werkwoord", "VT: liep (klinkerverandering)", "VD: ge- + lop + -en = gelopen"],
        "distractorExplanations": {
          "0": "Goed! Gelopen — sterk werkwoord, VD eindigt op -en.",
          "1": "'Geloopt' behandelt 'lopen' als zwak werkwoord met kofschip. Maar 'lopen' is sterk (liep, gelopen). Onthoud: sterke VD's eindigen op -en.",
          "2": "'Geloopen' heeft een dubbele 'o'. Maar in het VD schrijf je 'gelopen' met één 'o'. De klinker verandert niet in het VD.",
          "3": "'Gelopd' bestaat niet. Sterke werkwoorden eindigen op -en in het VD, niet op -d."
        }
      }
    },
    {
      "id": "SWW-VD-STERK-002",
      "familyId": "SWW-VD-STERK",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_sterk",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct?",
      "options": [
        "Hij heeft het boek geschreven.",
        "Hij heeft het boek geschrijft.",
        "Hij heeft het boek geschrijfd.",
        "Hij heeft het boek geschreeft."
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "verbConjugation",
          "data": { "verb": "schrijven", "type": "sterk", "forms": { "tt": ["schrijf", "schrijft", "schrijft", "schrijven"], "vt": ["schreef", "schreef", "schreef", "schreven"], "vd": ["geschreven"] }, "label": "Sterk werkwoord: schrijven" }
        }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Schrijven → geschreven", "content": "Schrijven is een sterk werkwoord:\nschrijven → schreef → geschreven\n\nHet VD eindigt op -en. De klinker verandert: ij → e.", "icon": "lightbulb" } }
      ],
      "conceptId": "vd_sterk_schrijven",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Schrijven → schreef → geschreven. Het VD van sterke werkwoorden eindigt op -en. De klinker verandert (ij → e). Zet om naar de ik-vorm om te checken: ik heb geschreven ✓.",
        "solutionSteps": ["Schrijven is sterk (schreef)", "VD: ge- + schrev + -en = geschreven", "Klinkerverandering: ij → e", "Check: ik heb geschreven ✓"],
        "distractorExplanations": {
          "0": "Goed! 'Geschreven' — sterk werkwoord, VD op -en.",
          "1": "Je dacht waarschijnlijk dat 'schrijven' een zwak werkwoord is. Maar 'schrijven' is sterk (schreef, geschreven). Onthoud: sterke VD's eindigen op -en, niet op -t.",
          "2": "Je dacht waarschijnlijk dat het VD op -d eindigt. Maar sterke werkwoorden eindigen op -en in het VD. Onthoud: geschreven, niet geschrijfd.",
          "3": "Je dacht waarschijnlijk dat je de VT-vorm (schreef) met -t combineert. Maar het VD is een aparte vorm: geschreven. Onthoud: VT = schreef, VD = geschreven."
        }
      }
    },
    {
      "id": "SWW-VD-STERK-003",
      "familyId": "SWW-VD-STERK",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_sterk",
      "questionType": "multiple_choice",
      "question": "Wat is het voltooid deelwoord van 'rijden'?",
      "options": ["gereden", "gerijdt", "gerijd", "gerijden"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "verbConjugation",
          "data": { "verb": "rijden", "type": "sterk", "forms": { "tt": ["rijd", "rijdt", "rijdt", "rijden"], "vt": ["reed", "reed", "reed", "reden"], "vd": ["gereden"] }, "label": "Sterk werkwoord: rijden" }
        }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Rijden → gereden", "content": "Rijden is sterk: rijden → reed → gereden.\nDe klinker verandert: ij → e.\nVD eindigt op -en.", "icon": "lightbulb" } }
      ],
      "conceptId": "vd_sterk_rijden",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Rijden → reed → gereden. Sterk werkwoord met klinkerverandering (ij → e). VD eindigt op -en. Zet om naar de ik-vorm: ik heb gereden ✓.",
        "solutionSteps": ["Rijden is sterk (reed)", "Klinkerverandering: ij → e", "VD: ge- + red + -en = gereden", "Check: ik heb gereden ✓"],
        "distractorExplanations": {
          "0": "Goed! 'Gereden' — klinkerverandering ij → e, VD op -en.",
          "1": "Je dacht waarschijnlijk dat 'rijden' een zwak werkwoord is. Maar 'rijden' is sterk (reed, gereden). Onthoud: sterke VD's eindigen op -en, niet op -t.",
          "2": "Je dacht waarschijnlijk dat het VD op -d eindigt zonder -en. Maar sterke werkwoorden eindigen altijd op -en in het VD. Onthoud: gereden, niet gerijd.",
          "3": "Je dacht waarschijnlijk dat de oorspronkelijke klinker (ij) behouden blijft. Maar bij sterke werkwoorden verandert de klinker: ij → e. Onthoud: gereden, niet gerijden."
        }
      }
    },
    {
      "id": "SWW-VD-STERK-004",
      "familyId": "SWW-VD-STERK",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_sterk",
      "questionType": "multiple_choice",
      "question": "Welk werkwoord heeft een STERK voltooid deelwoord (eindigt op -en)?",
      "options": ["zwemmen (gezwommen)", "fietsen (gefietst)", "werken (gewerkt)", "koken (gekookt)"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Sterk vs. zwak herkennen", "content": "Sterk VD: eindigt op -en (gelopen, geschreven, gezwommen)\nZwak VD: eindigt op -t of -d (gefietst, gewerkt, gekookt)\n\nTip: als de klinker verandert in de VT, is het sterk.", "icon": "lightbulb" } }
      ],
      "conceptId": "vd_sterk_herkennen",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Zwemmen → zwom → gezwommen. De klinker verandert (e → o) en het VD eindigt op -en → sterk. De andere drie zijn zwak: gefietst, gewerkt, gekookt (VD op -t).",
        "solutionSteps": ["Zwemmen: zwom (klinkerverandering) → sterk", "VD: gezwommen (op -en)", "Fietsen/werken/koken: geen klinkerverandering → zwak"],
        "distractorExplanations": {
          "0": "Goed! Gezwommen eindigt op -en → sterk werkwoord.",
          "1": "Gefietst eindigt op -t → zwak werkwoord (kofschip: 's').",
          "2": "Gewerkt eindigt op -t → zwak werkwoord (kofschip: 'k').",
          "3": "Gekookt eindigt op -t → zwak werkwoord (kofschip: 'k')."
        }
      }
    },
    {
      "id": "SWW-VD-STERK-005",
      "familyId": "SWW-VD-STERK",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_sterk",
      "questionType": "fill_in",
      "question": "Vul het voltooid deelwoord in: 'Zij heeft de hele dag ... (zingen).' Typ het woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["gezongen"],
        "caseSensitive": false,
        "placeholder": "ge..."
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Zingen → gezongen", "content": "Zingen is sterk: zingen → zong → gezongen.\nKlinkerverandering: i → o.\nVD: ge- + zong + -en = gezongen.", "icon": "lightbulb" } }
      ],
      "conceptId": "vd_sterk_zingen_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Zingen → zong → gezongen. Sterk werkwoord: klinkerverandering i → o, VD eindigt op -en.",
        "solutionSteps": ["Zingen is sterk (zong)", "VD: ge- + zong + -en = gezongen"]
      }
    },
    {
      "id": "SWW-VD-STERK-006",
      "familyId": "SWW-VD-STERK",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_sterk",
      "questionType": "error_spotting",
      "question": "In welke zin staat een fout bij het voltooid deelwoord? Klik op de fout.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sentences": [
          { "text": "Zij heeft de hele dag geschrijft.", "hasError": true, "correction": "geschreven", "explanation": "'Schrijven' is een sterk werkwoord: het VD is 'geschreven' (op -en), niet 'geschrijft' (op -t)." },
          { "text": "Hij heeft hard gelopen.", "hasError": false },
          { "text": "Wij hebben lang gezwommen.", "hasError": false },
          { "text": "Ik heb een brief geschreven.", "hasError": false }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Sterk VD eindigt op -en", "content": "Sterke werkwoorden hebben een VD dat eindigt op -en: geschreven, gelopen, gezwommen. NIET op -t of -d. 'Geschrijft' is fout — het moet 'geschreven' zijn.", "icon": "lightbulb" } }
      ],
      "conceptId": "vd_sterk_error",
      "variantIndex": 6,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Geschrijft' is fout. 'Schrijven' is een sterk werkwoord: schrijven → schreef → geschreven. Het VD eindigt op -en, niet op -t. De andere zinnen zijn correct: gelopen, gezwommen, geschreven.",
        "solutionSteps": [
          "Geschrijft → FOUT: schrijven is sterk → geschreven (op -en)",
          "Gelopen → goed (lopen → gelopen)",
          "Gezwommen → goed (zwemmen → gezwommen)",
          "Geschreven → goed (schrijven → geschreven)"
        ]
      }
    },
    {
      "id": "SWW-VD-STERK-007",
      "familyId": "SWW-VD-STERK",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_sterk",
      "questionType": "matching",
      "question": "Koppel elk sterk werkwoord aan het juiste voltooid deelwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "lopen", "right": "gelopen" },
          { "left": "schrijven", "right": "geschreven" },
          { "left": "rijden", "right": "gereden" },
          { "left": "zingen", "right": "gezongen" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Sterke VD's", "content": "Sterke werkwoorden veranderen van klinker en het VD eindigt op -en: lopen → gelopen, schrijven → geschreven, rijden → gereden, zingen → gezongen.", "icon": "lightbulb" } }
      ],
      "conceptId": "vd_sterk_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Lopen → gelopen, schrijven → geschreven (ij→e), rijden → gereden (ij → e), zingen → gezongen (i → o). Alle VD's eindigen op -en.",
        "solutionSteps": [
          "Lopen → gelopen",
          "Schrijven → geschreven (ij → e)",
          "Rijden → gereden (ij → e)",
          "Zingen → gezongen (i → o)"
        ]
      }
    }
  ]
}